import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, Typography, Paper, Snackbar, Alert } from '@mui/material';
import { Link, RouteComponentProps } from 'react-router-dom';

interface LoginProps extends RouteComponentProps {
  onLogin: (credentials: { phone: string; password: string }) => void;
  error?: string;
  onErrorClear: () => void;
}

const Login: React.FC<LoginProps> = ({ onLogin, error, onErrorClear }) => {
  const [formData, setFormData] = useState({
    phone: '',
    password: '',
  });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  useEffect(() => {
    if (error) {
      setSnackbarMessage(error);
      setSnackbarOpen(true);
    } else {
      setSnackbarOpen(false);
      setSnackbarMessage('');
    }
  }, [error]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    try {
      onLogin(formData);
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
    setSnackbarMessage('');
    onErrorClear();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        bgcolor: '#f5f5f5',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          width: '100%',
          maxWidth: 400,
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom align="center">
          تسجيل الدخول
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="رقم الهاتف"
            name="phone"
            type="text"
            value={formData.phone}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="كلمة المرور"
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
            margin="normal"
            required
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 3 }}
          >
            تسجيل الدخول
          </Button>
        </form>
        <Typography align="center" sx={{ mt: 2 }}>
          {" "}ليس لديك حساب؟ 
          <Link to="/signup" style={{ textDecoration: 'none', paddingRight: '5px' }}>
          سجل الآن
          </Link>
        </Typography>
        <Snackbar 
          open={snackbarOpen} 
          autoHideDuration={6000} 
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={handleSnackbarClose} severity="error" sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Paper>
    </Box>
  );
};

export default Login; 